import { render, staticRenderFns } from "./Sable.vue?vue&type=template&id=54904e94&scoped=true"
import script from "./Sable.vue?vue&type=script&lang=js"
export * from "./Sable.vue?vue&type=script&lang=js"
import style0 from "./Sable.vue?vue&type=style&index=0&id=54904e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54904e94",
  null
  
)

export default component.exports